import { render, staticRenderFns } from "./CouchdbWorkspaceModal.vue?vue&type=template&id=26cd8c10&"
import script from "./CouchdbWorkspaceModal.vue?vue&type=script&lang=js&"
export * from "./CouchdbWorkspaceModal.vue?vue&type=script&lang=js&"
import style0 from "./CouchdbWorkspaceModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CouchdbWorkspaceModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/CouchdbWorkspaceModal.vue
// module id = 2343
// module chunks = 1